// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"93546aca","977":"58dc5b0a"}[chunkId] + ".chunk.js";
};